import ActiveCalendar from "../public/images/icons/calendar-active.svg";
import ExpiredCalendar from "../public/images/icons/calendar-expired.svg";
import PendingCalendar from "../public/images/icons/calendar-pending.svg";
import AgricultureIcon from "../public/images/menu/agriculture.svg";
import DashboardIcon from "../public/images/menu/dashboard.svg";
import InventoryIcon from "../public/images/menu/inventory.svg";
import MachineryIcon from "../public/images/menu/machinery.svg";
import PlanningIcon from "../public/images/menu/planning.svg";
import ReportsIcon from "../public/images/menu/reports.svg";
import RocketIcon from "../public/images/menu/rocket.svg";
export { default as ExternalLinkIcon } from "../public/images/icons/external-link.svg";
export { default as AttachIcon } from "../public/images/icons/attach.svg";
import {
  DollarCircleOutlined,
  SettingOutlined,
  TeamOutlined,
} from "@ant-design/icons";

import MapOutline from "../public/images/menu/map-outline.svg";

// https://icomoon.io
export { default as CloudRainIcon } from "../public/images/icons/weather/cloud-rain.svg";
export { default as RaindropIcon } from "../public/images/icons/weather/raindrop.svg";
export { default as SunIcon } from "../public/images/icons/weather/sun.svg";
export { default as WindIcon } from "../public/images/icons/weather/wind.svg";
export { default as Briefcase } from "../public/images/icons/briefcase.svg";
export { default as Tractor } from "../public/images/icons/tractor.svg";

// custom
export { default as AreaIcon } from "../public/images/icons/area.svg";
export { default as AttendanceIcon } from "../public/images/icons/attendance.svg";
export { default as BuildingStructureIcon } from "../public/images/icons/building-structure.svg";
export { default as CommentIcon } from "../public/images/icons/comment.svg";
export { default as ConvertItemIcon } from "../public/images/icons/convert-item.svg";
export { default as CostCenterIcon } from "../public/images/icons/cost-center.svg";
export { default as CropsIcon } from "../public/images/icons/crops.svg";
export { default as DistributeIcon } from "../public/images/icons/distribute.svg";
export { default as ExpenseIcon } from "../public/images/icons/expense.svg";
export { default as FleetMachineryIcon } from "../public/images/icons/fleet-machinery.svg";
export { default as GlovesIcon } from "../public/images/icons/gloves.svg";
export { default as HarvestIcon } from "../public/images/icons/harvest.svg";
export { default as InputsIcon } from "../public/images/icons/inputs.svg";
export { default as LaborIcon } from "../public/images/icons/labor.svg";
export { default as MechanicIcon } from "../public/images/icons/mechanic.svg";
export { default as NotesIcon } from "../public/images/icons/notes.svg";
export { default as OdometerIcon } from "../public/images/icons/odometer.svg";
export { default as ProcessingPlantIcon } from "../public/images/icons/processing-plant.svg";
export { default as ProductIcon } from "../public/images/icons/product.svg";
export { default as SalesIcon } from "../public/images/icons/sales.svg";
export { default as SberIcon } from "../public/images/icons/sber.svg";
export { default as SprayIcon } from "../public/images/icons/spray.svg";
export { default as SprayingIcon } from "../public/images/icons/spraying.svg";
export { default as SprinkleIcon } from "../public/images/icons/sprinkle.svg";
export { default as TankIcon } from "../public/images/icons/tank.svg";
export { default as ThermometerHalfIcon } from "../public/images/icons/thermometer-half.svg";
export { default as TokensIcon } from "../public/images/icons/tokens.svg";
export { default as ToolsEquipmentIcon } from "../public/images/icons/tools-equipment.svg";
export { default as TruckIcon } from "../public/images/icons/truck.svg";
export { default as WaterIcon } from "../public/images/icons/water.svg";

export const MenuIcons = {
  PlanningIcon,
  AgricultureIcon,
  InventoryIcon,
  InfrastructureIcon: SettingOutlined,
  MachineryIcon,
  HrIcon: TeamOutlined,
  FinanceIcon: DollarCircleOutlined,
  ReportsIcon,
  DashboardIcon,
  MapOutline,
  RocketIcon,
};

export const CalendarIcons = {
  ActiveCalendar,
  PendingCalendar,
  ExpiredCalendar,
};
